import { render, staticRenderFns } from "./UserDashboardFacilitiesHomestays.vue?vue&type=template&id=12746064&scoped=true&"
import script from "./UserDashboardFacilitiesHomestays.vue?vue&type=script&lang=js&"
export * from "./UserDashboardFacilitiesHomestays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12746064",
  null
  
)

export default component.exports